export const REQUEST_LOAD = 'DASHBOARD/REQUEST_LOAD';
export const SET_PRODUCT = 'DASHBOARD/SET_PRODUCT';
export const UNSET_PRODUCT = 'DASHBOARD/UNSET_PRODUCT';
export const SET_STATUS = 'DASHBOARD/SET_STATUS';
export const OPEN_MODAL = 'DASHBOARD/OPEN_MODAL';
export const CLOSE_MODAL = 'DASHBOARD/CLOSE_MODAL';
